import React from 'react'
import loadable from '@loadable/component'
import LoadingIndicator from '../LoadingIndicator'

type Icon = {
  width: string | number;
  height: string | number;
  rotate?: string | number;
  icon: string;
  color: string;
  directory: string;
  className: string;
}

type OrangeIconProps = {
  icon: string;
  color?: string;
  size: string;
  className?: string;
}

interface IOrangeIcon {
  color?: string;
  size: string;
  className?: string;
}

function Icon ({ width = '', height = '', icon = '', color = 'orange-base', rotate = 0, directory = '', className = '' }: Icon) {
  const SvgIcon = loadable(() => import(`inter-frontend-svgs/lib/${directory}/${icon}`), {
    fallback: <LoadingIndicator size='small' />
  })

  return (
    <SvgIcon width={width} height={height} icon={icon} color={color} rotate={rotate} directory={directory} className={className} />
  )
}

export function OrangeIcon ({ icon, color, size, className }: OrangeIconProps) {
  const SvgIcon = loadable(() => import(`inter-frontend-svgs/lib/orangeds/${size}/${icon}`), {
    fallback: <LoadingIndicator size='small' />
  })

  return (
    <SvgIcon color={color} size={size} className={className} />
  )
}

export default Icon
